import request from '@/utils/request'
import requestJson from "@/utils/requestJson"
import service from '@/utils/request'
// import requestDown from "@/utils/requestDown"

// 商户商品接口
export function stockItemGetlist(data) {
  return request({
    url: '/admin/stock_item/getlist',
    method: 'get',
    params: data
  })
}
export function stockItemGetOne(data) {
  return request({
    url: '/admin/stock_item/getOne',
    method: 'get',
    params: data
  })
}
export function stockItemDel(data) {
  return request({
    url: '/admin/stock_item/del',
    method: 'get',
    params: data
  })
}
export function stockItemLock(data) {
  return request({
    url: '/admin/stock_item/lock',
    method: 'get',
    params: data
  })
}

export function stockItemActive(data) {
  return request({
    url: '/admin/stock_item/active',
    method: 'get',
    params: data
  })
}

export function stockItemUp(data) {
  return request({
    url: '/admin/stock_item/up',
    method: 'post',
    data
  })
}

export function stockItemAdd(data) {
  return request({
    url: '/admin/stock_item/add',
    method: 'post',
    data
  })
}

// 修改保质期
export function itemAlarmUp(data) {
  return request({
    url: '/admin/item_alarm/up',
    method: 'post',
    data
  })
}


// 门店商品管理
export function shopStockItemGetlist(data) {
  return request({
    url: '/admin/shop_stock_item/getlist',
    method: 'get',
    params: data
  })
}
export function shopStockItemDel(data) {
  return request({
    url: '/admin/shop_stock_item/del',
    method: 'get',
    params: data
  })
}

export function shopStockItemGetOne(data) {
  return request({
    url: '/admin/shop_stock_item/getOne',
    method: 'get',
    params: data
  })
}

export function shopStockItemUp(data) {
  return request({
    url: '/admin/shop_stock_item/up',
    method: 'post',
    data
  })
}

export function stockItemZeroStockLock(data) {
  return request({
    url: '/admin/stock_item/zeroStockLock',
    method: 'post',
    data
  })
}

export function stockItemGetNewList(data) {
  return request({
    url: '/admin/stock_item/getNewList',
    method: 'get',
    params: data
  })
}
export function StockItemBatchAdd(data) {
  return request({
    url: '/admin/stock_item/batchAdd',
    method: 'post',
    data
  })
}

export function TransactionGetList(data) {
  return request({
    url: '/admin/order_item/getorderlist',
    method: 'get',
    params: data
  })
}

export function StockItemAlarmGetList(data) {
  return request({
    url: '/admin/item_alarm/getlist',
    method: 'get',
    params: data
  })
}

export function StockItemAlarmAdd(data) {
  return request({
    url: '/admin/item_alarm/add',
    method: 'post',
    data
  })
}

export function StockItemAlarmDel(data) {
  return request({
    url: '/admin/item_alarm/del',
    method: 'get',
    params: data
  })
}

export function StockItemAlarmBatchDel(data) {
  return request({
    url: '/admin/item_alarm/batchDel',
    method: 'get',
    params: data
  })
}


// export function exportExcel(data) {
//   return requestDown({
//     url: '/admin/item_alarm/exportExcel',
// //    method: 'downLoad',
//     params: data
//   })
// }



// export function importExcel(data) {
//   return request({
//     url: '/admin/item_alarm/importExcel',
//     method: 'downLoad',
//     params: data
//   })
// }

export function StockItemWayGetList(data) {
  return request({
    url: '/admin/item_way/getlist',
    method: 'get',
    params: data
  })
}

export function StockItemWayGetBuyList(data) {
  return request({
    url: '/admin/item_way/getBuyItemWay',
    method: 'get',
    params: data
  })
}

export function StockItemWayGetSellList(data) {
  return request({
    url: '/admin/item_way/getSellItemWay',
    method: 'get',
    params: data
  })
}

export function StockItemWayAddList(data) {
  return requestJson({
    url: '/admin/item_way/addList',
    method: 'post',
    data
  })
}

export function StockItemWayDel(data) {
  return request({
    url: '/admin/item_way/del',
    method: 'get',
    params: data
  })
}

export function genItemWayCode(data) {
  return requestJson({
    url: '/admin/item_way/genItemWayCode',
    method: 'post',
    data
  })
}

export function updateProductList(data) {
  return requestJson({
    url: '/admin/Report_list/updateproductlist',
    method: 'post',
    params: data
  })
}


// 商户商品接口
export function syncAll() {
  return request({
    url: '/admin/stock_item/syncAll',
    method: 'get'
  })
}

// 批量同步库存
export function syncStockAll(params) {
  return request({
    url: '/admin/stock_item/syncStockAll',
    method: 'get',
    params: params
  })
}

// 导入商户商品
export function shopStockItemImportExcel(data) {
  return service({
    url: '/admin/Stock_item/importNewExcel',
    method: 'post',
    data: data
  })
}

// 获取商品图片列表（含分类）
export function stockItemImageGetList(params) {
  return service({
    url: '/admin/stock_item_image/getList',
    method: 'get',
    params: params
  })
}

// 抠图去背景
export function stockItemImageRemoveBg(data) {
  return request({
    url: '/admin/stock_item_image/removeBg',
    method: 'post',
    data
  })
}

// 更新商品图片（阿里云OSS）
export function stockItemUpdateImage(data) {
  return service({
    url: '/admin/stock_item_image/updateImage',
    method: 'post',
    data: data
  })
}

// 删除商品图片
export function stockItemDeleteImage(data) {
  return service({
    url: '/admin/stock_item_image/deleteImage',
    method: 'post',
    data: data
  })
}

// 保存图片排序
export function stockItemSaveImageSort(data) {
  return service({
    url: '/admin/stock_item_image/saveSort',
    method: 'post',
    data: data
  })
}

// 批量更新商户商品价格
export function shopStockItemUpdatePrice(data) {
  return service({
    url: '/admin/Stock_item/updatePrice',
    method: 'post',
    data: data
  })
}





// WEBPACK FOOTER //
// ./src/api/product.js